"use client";

import { c as _c } from "react/compiler-runtime";
import { Checkbox as MaterialCheckbox, FormControlLabel, FormGroup, FormHelperText } from "@mui/material";
import React from "react";
import styled from "styled-components";
import { Text, TextColor, TextSize, TextWeight } from "../Text";
const Checkbox = t0 => {
  const $ = _c(41);
  const {
    id,
    name,
    label,
    labelHtml,
    additionalLabel,
    checked,
    onChange,
    error,
    errorHelper,
    disabled: t1,
    white,
    compact,
    ref,
    alignStart,
    justifyStart,
    helperText
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const t2 = disabled ? _temp : onChange;
  const t3 = label === "" && !labelHtml;
  let t4;
  if ($[0] !== ref) {
    t4 = element => ref && ref(element);
    $[0] = ref;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== compact || $[3] !== disabled || $[4] !== error) {
    t5 = <BpCheckedIcon color="white" $compact={compact} className="checkbox-area-checked" $error={error} $disabled={disabled} />;
    $[2] = compact;
    $[3] = disabled;
    $[4] = error;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== error) {
    t6 = <BpIcon color="white" className="checkbox-area" $error={error} />;
    $[6] = error;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== checked || $[9] !== t5 || $[10] !== t6) {
    t7 = <MaterialCheckbox checkedIcon={t5} icon={t6} checked={checked} />;
    $[8] = checked;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== additionalLabel || $[13] !== alignStart || $[14] !== label || $[15] !== labelHtml || $[16] !== white) {
    t8 = label !== "" || labelHtml ? <LabelWrapper $alignStart={alignStart}>{labelHtml ? <Label text={labelHtml || !label ? "" : label} textHtml={labelHtml} weight={TextWeight.MEDIUM} fontSize={TextSize.S} color={white ? TextColor.WHITE : TextColor.GRAYSCALE_600} /> : <Text color={white ? TextColor.WHITE : TextColor.GRAYSCALE_600} fontSize={TextSize.S} text={label} />}{additionalLabel && <Text color={white ? TextColor.WHITE : TextColor.GRAYSCALE_600} fontSize={TextSize.S} text={additionalLabel} />}</LabelWrapper> : null;
    $[12] = additionalLabel;
    $[13] = alignStart;
    $[14] = label;
    $[15] = labelHtml;
    $[16] = white;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== id || $[19] !== name || $[20] !== t4 || $[21] !== t7 || $[22] !== t8) {
    t9 = <FormControlLabel id={id} name={name} ref={t4} control={t7} label={t8} />;
    $[18] = id;
    $[19] = name;
    $[20] = t4;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== error || $[25] !== errorHelper) {
    t10 = error && typeof errorHelper !== "undefined" && <ErrorFormHelperText>{errorHelper}</ErrorFormHelperText>;
    $[24] = error;
    $[25] = errorHelper;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== helperText) {
    t11 = typeof helperText !== "undefined" && helperText && <InfoFormHelperText><div dangerouslySetInnerHTML={{
        __html: helperText
      }} /></InfoFormHelperText>;
    $[27] = helperText;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== alignStart || $[30] !== checked || $[31] !== compact || $[32] !== disabled || $[33] !== error || $[34] !== justifyStart || $[35] !== t10 || $[36] !== t11 || $[37] !== t2 || $[38] !== t3 || $[39] !== t9) {
    t12 = <StyledFormGroup $checked={checked} onChange={t2} $disabled={disabled} $compact={compact} $error={error} $alignStart={alignStart} $justifyStart={justifyStart} $withoutLabel={t3}>{t9}{t10}{t11}</StyledFormGroup>;
    $[29] = alignStart;
    $[30] = checked;
    $[31] = compact;
    $[32] = disabled;
    $[33] = error;
    $[34] = justifyStart;
    $[35] = t10;
    $[36] = t11;
    $[37] = t2;
    $[38] = t3;
    $[39] = t9;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  return t12;
};
const Label = styled(Text)`
  div {
    font-size: ${({
  theme
}) => theme.fontSizes.s};
  }

  span {
    color: ${({
  theme
}) => theme.colors.ERROR_500};
    font-size: ${({
  theme
}) => theme.fontSizes.s};
    font-weight: ${({
  theme
}) => theme.fontWeights.bold};
  }
`;
const InfoFormHelperText = styled(FormHelperText)`
  line-height: 20px;
  color: ${({
  theme
}) => theme.colors.GRAYSCALE_500} !important;
  margin-left: 45px;
`;
const ErrorFormHelperText = styled(FormHelperText)`
  position: absolute;
  bottom: -20px;
  left: 0;
  color: ${({
  theme
}) => theme.colors.ERROR_500} !important;
  line-height: 20px;
  text-align: right !important;
  margin-left: 45px;
`;
const LabelWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  a {
    color: ${({
  theme
}) => theme.colors.BLUE} !important;
  }

  ${({
  $alignStart
}) => $alignStart && `
      padding-top: 8px;
    `}
`;
const StyledFormGroup = styled(FormGroup)`
  position: relative;
  margin-bottom: 8px;

  .MuiButtonBase-root {
    padding: ${({
  $compact
}) => $compact ? "3px 0px 0px" : "8px"};
    margin-right: ${({
  $compact
}) => $compact ? "12px" : "4px"};
    margin-left: ${({
  $compact
}) => $compact ? "0px" : "-8px"};

    ${({
  $withoutLabel
}) => $withoutLabel && `
      margin: 0 !important;
      padding: 0 !important;
      `}
  }

  .MuiFormControlLabel-root {
    margin-left: 0;
    display: flex;
    justify-content: ${({
  $justifyStart
}) => $justifyStart ? "flex-start" : "center"};
    align-items: ${({
  $alignStart
}) => $alignStart ? "flex-start" : "center"};
    padding-right: ${({
  $withoutLabel
}) => $withoutLabel ? "0px" : "8px"};

    ${({
  theme,
  $checked
}) => $checked && `
    border-radius: ${theme.radii.default};
  `}

    ${({
  $alignStart
}) => $alignStart && `
      .MuiTypography-root {
        > div {
          padding-top: 0;
        }
      }
    `}
  }

  .MuiFormControlLabel-label {
    padding-top: 2px;
    color: ${({
  theme
}) => theme.colors.BLACK};
  }

  a {
    color: ${({
  theme
}) => theme.colors.BLACK};
  }

  .dot {
    font-size: 15px;
    margin-left: 5px;
    color: ${({
  theme
}) => theme.colors.ERROR_500};
  }

  .error-helper {
    margin-left: 5px;
    color: ${({
  theme
}) => theme.colors.ERROR_500} !important;
    font-size: 0.75rem;
  }

  .checkbox-area,
  .checkbox-area-checked {
    width: ${({
  $compact
}) => $compact ? "16px" : "24px"};
    height: ${({
  $compact
}) => $compact ? "16px" : "24px"};
    border-radius: ${({
  theme,
  $compact
}) => $compact ? theme.radii.smaller : theme.radii.default};
  }

  .checkbox-area {
    background-color: ${({
  theme,
  $disabled
}) => $disabled ? theme.colors.GRAYSCALE_100 : theme.colors.WHITE};
    border: 2px solid
      ${({
  $error,
  theme
}) => $error ? theme.colors.ERROR_300 : theme.colors.GRAYSCALE_200};
  }

  .checkbox-area-checked {
    background-color: ${({
  theme,
  $disabled
}) => $disabled ? theme.colors.GRAYSCALE_200 : theme.colors.PRIMARY_500};
  }

  // Hover behavior
  &:hover {
    .MuiButtonBase-root {
      &:before {
        width: ${({
  $checked,
  $disabled,
  $compact
}) => $checked || $disabled ? 0 : $compact ? "12px" : "17px"};
        height: ${({
  $checked,
  $disabled,
  $compact
}) => $checked || $disabled ? 0 : $compact ? "12px" : "17px"};
        position: absolute;
        content: "";
      }
    }

    ${({
  $disabled,
  theme
}) => !$disabled && `
        .checkbox-area {
          background-color: ${theme.colors.WHITE};
          border: 1px solid ${theme.colors.GRAYSCALE_300};
        }
    `}
  }
`;
const BpIcon = styled.span`
  border: 2px solid ${({
  theme
}) => theme.colors.GRAYSCALE_400} !important;

  ${({
  theme,
  $error
}) => $error && `
  border: 2px solid ${theme.colors.ERROR_300} !important;
  `};
`;
const BpCheckedIcon = styled(BpIcon)`
  &:before {
    display: block;
    margin: ${({
  $compact
}) => $compact ? "0px" : "1.5px"};
    width: ${({
  $error,
  $compact
}) => $error ? "23px" : $compact ? "12px" : "17px"};
    height: ${({
  $error,
  $compact
}) => $error ? "23px" : $compact ? "12px" : "17px"};
    ${({
  $disabled
}) => $disabled ? `
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%2398A2B3'/%3E%3C/svg%3E");
    ` : `
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23FFF'/%3E%3C/svg%3E");
    `}

    content: "";
  }
`;
export default Checkbox;
function _temp() {
  return console.log("disabled");
}